import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from '../config/configureFirebase';
import { onValue, runTransaction, get, off, push } from "firebase/database";
import { driverQueue } from '../other/sharedFunctions';

let tasksListenerAttached = false;

export const fetchTasks = () => (dispatch) => {
  const { auth, tasksRef } = firebase;

  const uid = auth?.currentUser?.uid;
  if (!uid) {
    dispatch({
      type: FETCH_TASKS_FAILED,
      payload: store.getState().languagedata.defaultLanguage.no_tasks,
    });
    return;
  }

  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });

  if (tasksListenerAttached) {
    off(tasksRef());
    tasksListenerAttached = false;
  }

  onValue(
    tasksRef(),
    (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();

        const arr = Object.keys(data)
          .map((i) => {
            const item = data[i];
            item.id = i;
            return item;
          })
          .filter((item) => {
            return (
              item.requestedDrivers &&
              item.requestedDrivers[uid] &&
              item.status === "NEW"
            );
          })
          .sort((a, b) => {
            const aTime = new Date(a.tripdate).getTime() || 0;
            const bTime = new Date(b.tripdate).getTime() || 0;
            return aTime - bTime;
          });

        dispatch({
          type: FETCH_TASKS_SUCCESS,
          payload: arr,
        });
      } else {
        dispatch({
          type: FETCH_TASKS_SUCCESS,
          payload: [],
        });
      }
    },
    (error) => {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload:
          error?.message ||
          store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  );

  tasksListenerAttached = true;
};

export const stopFetchTasks = () => () => {
  const { tasksRef } = firebase;
  off(tasksRef());
  tasksListenerAttached = false;
};

export const acceptTask = (task) => (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  onValue(
    singleUserRef(uid),
    (snapshot) => {
      let profile = snapshot.val();

      runTransaction(singleBookingRef(task.id), (booking) => {
        if (!booking) return booking;

        let fleetCommission_fee = profile?.fleetadmin
          ? (
              (parseFloat(booking?.estimate || 0) -
                parseFloat(booking?.convenience_fees || 0)) *
              parseFloat(booking?.fleet_admin_comission || 0) /
              100
            ).toFixed(2)
          : 0;

        let driver_fee = parseFloat(
          parseFloat(booking?.estimate || 0) -
            (
              parseFloat(booking?.convenience_fees || 0) +
              parseFloat(fleetCommission_fee || 0)
            )
        ).toFixed(2);

        if (booking.requestedDrivers || booking.driver === uid || booking.status === "NEW") {
          booking.driver = uid;
          booking.driver_image = profile?.profile_image ? profile.profile_image : "";
          booking.car_image = profile?.car_image ? profile.car_image : "";
          booking.driver_name = profile?.firstName + " " + profile?.lastName;
          booking.driver_contact = profile?.mobile;
          booking.driver_token = profile?.pushToken ? profile.pushToken : '';
          booking.vehicle_number = profile?.vehicleNumber ? profile.vehicleNumber : "";
          booking.vehicleModel = profile?.vehicleModel ? profile.vehicleModel : "";
          booking.vehicleMake = profile?.vehicleMake ? profile.vehicleMake : "";
          booking.driverRating = profile?.rating ? profile.rating : "0";
          booking.fleetCommission = fleetCommission_fee ? fleetCommission_fee : "0";
          booking.fleetadmin = profile?.fleetadmin ? profile.fleetadmin : "";
          booking.status = "ACCEPTED";
          booking.driver_share = driver_fee ? driver_fee : "0";
          booking.driverDeviceId = task?.driverDeviceId ? task.driverDeviceId : null;
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          return booking;
        }

        return booking;
      })
        .then(() => {
          get(singleBookingRef(task.id))
            .then((snapshot) => {
              if (!snapshot.exists()) {
                return;
              } else {
                let booking = snapshot.val();
                let requestedDrivers = booking?.requestedDrivers;
                let driverId = booking?.driver;

                if (requestedDrivers == undefined && driverId === uid) {
  const rawTripDate = task?.tripdate;
  const tripMs =
    typeof rawTripDate === "number"
      ? rawTripDate
      : new Date(rawTripDate).getTime();

  const isUpcomingBookLater =
    task?.bookLater === true &&
    Number.isFinite(tripMs) &&
    tripMs > Date.now();

  // Kun sæt queue=true for aktuelle ture.
  // Kommende Book Later-ture skal ikke blokere nye kommende notifikationer.
  updateProfile({ queue: isUpcomingBookLater ? false : true })(dispatch);

  if (task.customer_token) {
    RequestPushMsg(task.customer_token, {
      title:
        store.getState().languagedata.defaultLanguage.notification_title,
      msg:
        profile.firstName +
        store.getState().languagedata.defaultLanguage.accept_booking_request,
      screen: "BookedCab",
      params: { bookingId: task.id },
    });
  }

                  const driverLocation = store.getState().gpsdata.location;

                  if (driverLocation?.lat && driverLocation?.lng) {
                    push(trackingRef(task.id), {
                      at: new Date().getTime(),
                      status: "ACCEPTED",
                      lat: driverLocation.lat,
                      lng: driverLocation.lng,
                    });
                  }

                  dispatch({
                    type: ACCEPT_TASK,
                    payload: { task: task },
                  });

                  fetchTasks()(dispatch);
                }
              }
            })
            .catch((error) => {
              console.error(error);
            });
        });
    },
    { onlyOnce: true }
  );
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  runTransaction(singleBookingRef(bookingId), (booking) => {
    if (booking && booking.requestedDrivers) {
      if (
        booking.requestedDrivers !== null &&
        Object.keys(booking.requestedDrivers).length === 1
      ) {
        booking.status = "NEW";
        booking.requestedDrivers = null;
        booking.driverEstimates = null;

        if (booking.customer_token) {
          RequestPushMsg(booking.customer_token, {
            title:
              store.getState().languagedata.defaultLanguage.notification_title,
            msg:
              store.getState().languagedata.defaultLanguage.booking_cancelled +
              bookingId,
            screen: "BookedCab",
            params: { bookingId: bookingId },
          });
        }

        dispatch({
          type: CANCEL_TASK,
          payload: { uid: uid, bookingId: bookingId },
        });
      } else {
        delete booking.requestedDrivers[uid];
      }

      if (booking.driverOffers && booking.driverOffers[uid]) {
        delete booking.driverOffers[uid];
      }

      if (booking.selectedBid && booking.selectedBid.driver === uid) {
        delete booking.selectedBid;
      }

      return booking;
    }

    return booking;
  }).then(() => {
    fetchTasks()(dispatch);
  });
};